<template>
  <div id="authority">
    <!-- 权限管理 -->
    <div class="auth">
      <div class="item title">
        <div class="stt">角色管理</div>
        <span><i class="el-icon-plus" @click="addRole"></i></span>
      </div>
      <div class="item" v-for="(item, index) in authList" :key="index">
        <span class="stt" @click="showAuth(item, index)">{{ item.name }}</span>
        <span v-if="item.name != '超级管理员'">
          <!--  -->
          <i
            class="el-icon-delete-solid"
            @click="deleteAuth(item)"
            style="color: #ee6e6e"
          ></i
        ></span>
      </div>
    </div>
    <div class="content">
      <div class="top">
        <div class="va" v-if="flag">
          {{ tempAuth.name }}
          <i
            class="el-icon-edit-outline"
            @click="flag = false"
            v-if="isEdit"
          ></i>
        </div>
        <div v-else class="in">
          <el-input
            v-model="tempAuth.name"
            placeholder="请输入角色名称"
            clearable
            @keyup.enter.native="changeAuthName"
          ></el-input>
        </div>
      </div>
      <div class="below">
        <div class="left">
          <div class="title">
            <div class="va">权限配置:</div>
            <div class="but" @click="editAuthority" v-if="isEdit">确定</div>
          </div>
          <div class="content">
            <div class="item" v-for="(item, index) in modelList" :key="index">
              <div class="ti">{{ item.name }}:</div>
              <el-switch v-model="item.authority" :disabled="!isEdit">
              </el-switch>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="title">
            <div class="va">人员设置:</div>
            <div class="but" @click="addUser">添加用户</div>
          </div>
          <div class="content">
            <el-table
              :data="userList"
              stripe
              style="width: 100%"
              border
              height="600"
            >
              <el-table-column prop="name" label="姓名" width="180">
              </el-table-column>
              <el-table-column prop="account" label="账号" width="180">
              </el-table-column>
              <el-table-column label="角色调整" width="120">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.row, 0)"
                    type="text"
                    size="small"
                    >调整</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="handleClick(scope.row, 1)"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    @click="handleClick(scope.row, 2)"
                    size="small"
                    >重置密码</el-button
                  >
                  <el-button
                    style="color: red"
                    type="text"
                    @click="handleClick(scope.row, 3)"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :dialogData="dialogData.data"
      :buttonArray="dialogData.buttonArray"
      @butClick="butClick"
      @cancelDialog="cancelDialog"
    ></diy_dialog>
  </div>
</template>

<script>
import * as authorityData from "./authority.js";
import * as formatData from "../../utils/formatMathDecimal.js";
export default {
  data() {
    return {
      authList: authorityData.getAuthorityList(), // 角色列表
      tempAuth: {
        //   临时权限,用于右侧信息获取
        name: "超级管理员",
        id: "",
      },
      flag: true, // 角色名称是否处在编辑
      isEdit: true, // 是否可以编辑  超级管理员不可编辑
      modelList: authorityData.changeModelToValue(authorityData.getModelList()), // 当前角色的权限列表
      userList: authorityData.getUserList(), // 当前角色下所有用户列表
      dialogData: {
        flag: false,
        tempId: "", // 用于临时存储相关ID
        title: "",
        buttonArray: [],
        data: [],
      },
      roleIndex: 0,
    };
  },
  methods: {
    /**
     * 获取角色列表
     */
    getAllAuthList() {
      this.$request("post", "/role/roleList", {}, (data) => {
        this.authList = data;
        this.showAuth(data[this.roleIndex], this.roleIndex);
      });
    },
    /**
     * 查看角色详情
     */
    showAuth(auth, index) {
      this.roleIndex = index;
      this.tempAuth = JSON.parse(JSON.stringify(auth));
      this.isEdit = auth.name != "超级管理员";
      this.getAuthorityByRole();
    },
    /**
     * 获取角色权限
     */
    getAuthorityByRole() {
      let requestData = {
        roleId: this.tempAuth.id,
      };
      this.$request(
        "post",
        "/authority/getAuthorityByRole",
        requestData,
        (data) => {
          this.modelList = authorityData.changeModelToValue(data);
          this.getUserList();
        }
      );
    },
    /**
     * 获取当前角色下人员列表
     */
    getUserList() {
      let requestData = {
        roleId: this.tempAuth.id,
      };
      this.$request("post", "/user/getUserList", requestData, (data) => {
        this.userList = data;
      });
    },
    /**
     * 删除角色
     * 删除当前角色的所有权限配置
     * 当前角色下的用户?
     *    同时删除当前角色下的所有用户
     */
    deleteAuth(item) {
      this.$confirm(
        "此操作将永久删除该角色信息,同时删除该角色下的所有用户, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$request("post", "/role/delRole", { id: item.id }, (data) => {
            this.getAllAuthList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    /**
     * 添加角色弹出框
     */
    addRole() {
      this.dialogData.title = "添加角色";
      this.dialogData.tempId = "";
      this.dialogData.data = [
        { title: "角色名称", type: "input", value: "", key: "name" },
      ];
      this.dialogData.buttonArray = [
        { name: "确认", active: "sureAddRole", type: "primary" },
        { name: "取消", active: "cancel", type: "info" },
      ];
      this.dialogData.flag = true;
    },
    /**
     * 修改角色名称
     */
    changeAuthName() {
      if (this.tempAuth.name == "") {
        this.$message({
          message: "角色名称不可为空!",
          type: "error",
        });
        return;
      }
      this.flag = true;
      this.saveRole(this.tempAuth);
    },
    /**
     * 添加/修改角色名称
     */
    saveRole(requestData) {
      this.$request("post", "/role/saveRole", requestData, (data) => {
        this.$message({
          message: "操作成功!",
          type: "success",
        });
        this.getAllAuthList();
        this.cancelDialog();
      });
    },
    /**
     * 确定修改当前角色的权限
     */
    editAuthority() {
      let requestData = authorityData.changeValueToModel(
        JSON.parse(JSON.stringify(this.modelList))
      );
      console.log("确定修改角色权限", requestData);
      this.$request("post", "/authority/editAuthority", requestData, (data) => {
        this.$message({
          message: "权限修改成功!",
          type: "success",
        });
      });
    },
    /**
     * 添加用户弹出框
     */
    addUser() {
      this.dialogData.title = "添加用户";
      this.dialogData.tempId = "";
      this.dialogData.data = [
        { title: "姓名", type: "input", value: "", key: "name" },
        { title: "账号", type: "input", value: "", key: "account" },
      ];
      this.dialogData.buttonArray = [
        { name: "确认", active: "sureAddUser", type: "primary" },
        { name: "取消", active: "cancel", type: "info" },
      ];
      this.dialogData.flag = true;
    },
    /**
     * 人员操作
     */
    handleClick(user, flag) {
      let requestData = {};
      switch (flag) {
        case 0:
          // 调整角色
          requestData = {
            roleId: this.tempAuth.id,
          };
          this.$request("post", "/user/getUserList", requestData, (data) => {
            this.userList = data;
            if (!this.isEdit && this.userList.length == 1) {
              // 超级管理员必有一条数据,不可删除
              this.$message({
                type: "error",
                message: "超级管理员至少要有一个账户不可被调整为其他角色!",
              });
              return;
            }
            this.dialogData.title = "角色调整";
            this.dialogData.tempId = user.id;
            let roleList = [];
            this.authList.forEach((element) => {
              let dd = {
                label: element.name,
                value: element.id,
              };
              roleList.push(dd);
            });
            this.dialogData.data = [
              {
                title: "角色",
                type: "select",
                value: "",
                key: "roleId",
                options: roleList,
              },
            ];
            this.dialogData.buttonArray = [
              { name: "确认", active: "sureChangeUserRole", type: "primary" },
              { name: "取消", active: "cancel", type: "info" },
            ];
            this.dialogData.flag = true;
          });

          break;
        case 1:
          // 编辑用户
          this.dialogData.title = "编辑用户";
          this.dialogData.tempId = user.id;
          this.dialogData.data = [
            { title: "姓名", type: "input", value: user.name, key: "name" },
            {
              title: "账号",
              type: "input",
              value: user.account,
              key: "account",
            },
          ];
          this.dialogData.buttonArray = [
            { name: "确认", active: "sureAddUser", type: "primary" },
            { name: "取消", active: "cancel", type: "info" },
          ];
          this.dialogData.flag = true;
          break;
        case 2:
          // 重置密码
          this.$confirm("此操作将重置当前用户的账户密码, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$request(
                "post",
                "/user/resetPwd",
                { id: user.id },
                (data) => {
                  this.$message({
                    type: "success",
                    message: "密码重置成功!",
                  });
                }
              );
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
          break;
        case 3:
          // 删除用户
          requestData = {
            roleId: this.tempAuth.id,
          };
          this.$request("post", "/user/getUserList", requestData, (data1) => {
            this.userList = data1;
            if (!this.isEdit && this.userList.length == 1) {
              // 超级管理员必有一条数据,不可删除
              this.$message({
                type: "error",
                message: "超级管理员至少要有一个账户不可被删除!",
              });
              return;
            }
            this.$confirm("此操作将永久删除当前用户, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.$request(
                  "post",
                  "/user/delUser",
                  { id: user.id },
                  (data) => {
                    this.getUserList();
                    this.$message({
                      type: "success",
                      message: "删除成功!",
                    });
                  }
                );
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
          });

          break;

        default:
          break;
      }
    },
    /**
     * 弹出框点击事件
     */
    butClick(active) {
      let requestData = {};
      let notNull = true;
      switch (active) {
        case "cancel":
          // 弹出框关闭
          this.cancelDialog();
          break;
        case "sureAddRole":
          //  确认添加角色
          requestData = {
            id: "",
          };
          this.dialogData.data.forEach((element) => {
            if (element.value == "") {
              notNull = false;
            }
            this.$set(requestData, element.key, element.value);
          });
          // 非空校验
          if (!notNull) {
            this.$message({
              message: "角色名称不可为空!",
              type: "error",
            });
            return;
          }
          this.saveRole(requestData);
          break;
        case "sureAddUser":
          // 确认添加/修改用户
          requestData = {
            id: this.dialogData.tempId,
            roleId: this.tempAuth.id,
          };
          this.dialogData.data.forEach((element) => {
            if (element.value == "") {
              notNull = false;
            }
            this.$set(requestData, element.key, element.value);
          });
          // 非空校验
          if (!notNull) {
            this.$message({
              message: "姓名或账号不可为空!",
              type: "error",
            });
            return;
          }
          // 校验账号  只能为数字或字母
          if (!formatData.formatMathOrLetter(requestData.account)) {
            this.$message({
              message: "账号只能为数字或字母格式!",
              type: "error",
            });
            return;
          }
          this.$request("post", "/user/saveUser", requestData, (data) => {
            this.$message({
              message: "人员添加成功!",
              type: "success",
            });
            this.getUserList();
            this.cancelDialog();
          });
          break;
        case "sureChangeUserRole":
          // 确认调整用户角色信息
          requestData = {
            userId: this.dialogData.tempId,
          };
          this.dialogData.data.forEach((element) => {
            if (element.value == "") {
              notNull = false;
            }
            this.$set(requestData, element.key, element.value);
          });
          // 非空校验
          if (!notNull) {
            this.$message({
              message: "角色不可为空!",
              type: "error",
            });
            return;
          }
          this.$request("post", "/user/changeRole", requestData, (data) => {
            this.$message({
              message: "人员角色调整成功!",
              type: "success",
            });
            this.getUserList();
            this.cancelDialog();
          });
          break;
        default:
          break;
      }
    },
    /**
     * 关闭弹出框事件
     */
    cancelDialog() {
      this.dialogData.flag = false;
    },
  },
  mounted() {
    this.getAllAuthList();
  },
};
</script>

<style lang="less" scoped>
#authority {
  width: 100%;
  height: 100%;
  display: flex;
  //   flex-direction: column;
  //   padding: 15px;
  box-sizing: border-box;

  .top,
  .auth,
  .left,
  .right {
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    box-sizing: border-box;
  }
  > .auth {
    width: 240px;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    overflow-y: auto;
    > .item {
      width: 100%;
      height: 50px;
      min-height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
      font-size: 14px;
      padding: 0 20px;
      border-bottom: 1px solid #e7e7e7;
      cursor: pointer;
      > .stt {
        width: 0;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 100%;
      }
      i {
        color: #0076fc;
        cursor: pointer;
      }
    }
    > .title {
      font-size: 18px;
      font-weight: bolder;
      height: 70px;
      border-bottom: 1px solid #d1e7ff;
      cursor: auto;
    }
  }
  > .content {
    width: 0;
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    > .top {
      height: 80px;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 30px;
      box-sizing: border-box;
      > .va {
        font-size: 15px;
        font-weight: bolder;
        i {
          margin-left: 15px;
          cursor: pointer;
        }
      }
      > .in {
        width: 550px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
      }
    }
    > .below {
      height: 0;
      flex: 1;
      margin-top: 20px;
      width: 100%;
      display: flex;
      > .left,
      > .right {
        height: 100%;
        width: 0;
        flex: 1;
        padding: 0 30px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        > .title {
          width: 100%;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          font-size: 15px;
          font-weight: bolder;
          > .va {
            width: 0;
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
          }
          > .but {
            width: auto;
            background-color: #0076fc;
            color: #ffffff;
            padding: 6px 30px;
            box-sizing: border-box;
            border-radius: 5px;
            cursor: pointer;
            transition: 0.3s;
            &:hover {
              background-color: #1560b6;
            }
          }
        }
        > .content {
          width: 100%;
          height: 0;
          flex: 1;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          > .item {
            width: 100%;
            height: 50px;
            min-height: 50px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            > .ti {
              width: 120px;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              font-size: 14px;
              font-weight: bolder;
              padding-right: 12px;
              box-sizing: border-box;
            }
          }
        }
      }
      > .left {
        margin-right: 10px;
      }
      > .right {
        flex: 1.8;
        margin-left: 10px;
      }
    }
  }
}
</style>